import {Controller} from '@hotwired/stimulus';

export default class extends Controller {

    static targets = ['slides', 'dots', 'prevButton', 'nextButton']

    connect() {
        const dots = this.dotsTarget.children;
        const slides = this.slidesTarget.children;
        let c = 0;

        for (const slide of slides) {
            slide.dataset.count = c;

            if (c === 0) {
                slide.dataset.first = true;
            }


            if (c === (slides.length - 1)) {
                slide.dataset.last = true;
            }
            c++;
        }

        let i = 0;
        for (const dot of dots) {
            dot.dataset.count = i;
            i++
        }
    }

    appear(e) {

        const element = e.target;
        const dots = this.dotsTarget.children;
        const slides = this.slidesTarget.children;

        if (element.id === 'primapagina-4') {
            if (typeof ga !== "undefined") {
                ga('send', 'event', {
                    'eventCategory': 'Scroll Primapagina',
                    'eventAction': 'Scrollato'
                });
            }
        }

        if (element.dataset.first === "true") {
            this.prevButtonTarget.classList.add('disabled')
            this.nextButtonTarget.classList.remove('disabled')

            this.nextButtonTarget.dataset.to = slides[Number(element.dataset.count) + 1].id

        } else if (element.dataset.last === "true") {
            this.nextButtonTarget.classList.add('disabled')
            this.prevButtonTarget.classList.remove('disabled')

            this.prevButtonTarget.dataset.to = slides[Number(element.dataset.count) - 1].id

        } else {
            this.nextButtonTarget.classList.remove('disabled')
            this.prevButtonTarget.classList.remove('disabled')

            this.prevButtonTarget.dataset.to = slides[Number(element.dataset.count) - 1].id
            this.nextButtonTarget.dataset.to = slides[Number(element.dataset.count) + 1].id

        }

        for (const dot of dots) {
            if (dot.dataset.count === element.dataset.count) {
                dot.classList.add('selected')
            } else {
                dot.classList.remove('selected')
            }
        }
    }


    scrollTo(e) {

        /*
        * prevent main header scroll down
        */

        const mainHeader = document.getElementById("main-header");
        if (mainHeader) {
            mainHeader.classList.add('hide-force');

            setTimeout(() => {
                mainHeader.classList.remove('hide-force');
            }, 5000)
        }


        const target = document.getElementById(e.currentTarget.dataset.to);
        target.scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"})
    }

}